var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaintenence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0b6462;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.529,17,16.5,11.97a3.19,3.19,0,0,0-3.669-.6l-4.58-4.58V4.125L2.748,0,0,2.75l4.125,5.5H6.792l4.58,4.58a3.2,3.2,0,0,0,.6,3.669L17,21.53a1.6,1.6,0,0,0,2.264,0l2.264-2.264A1.605,1.605,0,0,0,21.529,17ZM14.251,9.667A4.521,4.521,0,0,1,17.469,11l.834.834a6.082,6.082,0,0,0,1.882-1.267,6.179,6.179,0,0,0,1.628-5.873.514.514,0,0,0-.864-.236l-3.2,3.2-2.917-.485-.486-2.917,3.2-3.2A.519.519,0,0,0,17.3.185a6.19,6.19,0,0,0-5.869,1.628,6.088,6.088,0,0,0-1.77,4.451l3.528,3.527A4.681,4.681,0,0,1,14.251,9.667ZM9.786,13.19,7.35,10.754.8,17.306a2.749,2.749,0,0,0,3.888,3.888L10,15.884a4.614,4.614,0,0,1-.215-2.694ZM2.748,20.279A1.031,1.031,0,1,1,3.78,19.248,1.034,1.034,0,0,1,2.748,20.279Z",
    transform: "translate(0.004)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenence);
export default __webpack_public_path__ + "static/media/maintenence.27cfeee60a244e1f907c037e5958520b.svg";
export { ForwardRef as ReactComponent };